import type { ProjectKey } from '@atlassian/jira-shared-types';
import type { EditableComponent, CreatedComponent } from '../../common/model/types';
import componentHandler from '../../common/services/component-handler';
import { create as createRequest, type CreateRequestPayload } from '../rest/create';

import { transformComponent } from './transform';
import { getBaseUrl } from './index';

export const create = (
	projectId: number,
	projectKey: ProjectKey,
	component: EditableComponent,
): Promise<CreatedComponent> => {
	const { name, description, lead, defaultAssignee } = component;
	const componentLeadField = lead && { leadAccountId: lead.accountId };

	const payload: CreateRequestPayload = {
		name,
		description,
		assigneeType: defaultAssignee,
		project: projectKey,
		projectId,
		...componentLeadField,
	};

	return componentHandler(createRequest(getBaseUrl(), payload), transformComponent, projectKey);
};
